import React, { createContext, useContext, useState } from 'react';

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [popup, setPopup] = useState({
    show: false,
    title: '',
    message: '',
    type: 'alert', // 'alert' | 'confirm'
    onConfirm: null,
    onCancel: null,
  });

  const showAlert = (title, message) => {
    return new Promise((resolve) => {
      setPopup({
        show: true,
        title,
        message,
        type: 'alert',
        onConfirm: () => {
          setPopup((prev) => ({ ...prev, show: false }));
          resolve(true);
        },
      });
    });
  };

  const showConfirm = (title, message) => {
    return new Promise((resolve) => {
      setPopup({
        show: true,
        title,
        message,
        type: 'confirm',
        onConfirm: () => {
          setPopup((prev) => ({ ...prev, show: false }));
          resolve(true);
        },
        onCancel: () => {
          setPopup((prev) => ({ ...prev, show: false }));
          resolve(false);
        },
      });
    });
  };

  return (
    <PopupContext.Provider value={{ popup, showAlert, showConfirm }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
